














import { defineComponent, computed } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "AttributeGroupValue",
  props: {
    attributeGroupValue: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const isLink = computed(() => props.attributeGroupValue.startsWith("http"));
    return {
      isLink,
    };
  },
});
